import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { useDispatch, useSelector } from "react-redux";
import storage from "../../../utils/storage";
import { useFormik } from "formik";
import appActions from "../../../appActions";
import { InputText } from "primereact/inputtext";
import { selectedTimeZoneTemplate, statusOptions, timeZoneOptionTemplate, timeZonesOptions } from "../../../utils/mics";
import { MultiSelect } from 'primereact/multiselect';

const SitesForm = ({ site, isEditMode, isViewMode, onClose, onSave }) => {
    
    const dispatch = useDispatch();
    const currentUser = JSON.parse(storage.get('loginUser'));
    const siteGroupOptions = useSelector((state) => state.common.siteGroupList);

    const formik = useFormik({
        initialValues: {
            siteId: site?.siteId  || "",
            siteType: site?.siteType  || "",
            siteGroup: site?.siteGroup ? site?.siteGroup?.split(',') : [],
            title: site?.title  || "",
            description: site?.description  || "",
            region: site?.region  || "",
            country: site?.country  || "",
            city: site?.city  || "",
            siteLocation: site?.siteLocation  || "",
            status: site?.status || "Active",
            timeZone: site?.timeZone || '',
            lastUpdatedBy: currentUser?.userId || "",
        },
        enableReinitialize: true,
        validate: (data) => {
            let errors = {};
            if (!data.siteId) errors.siteId = 'Site Id is required.';
            if (!data.siteType) errors.siteType = 'Site Type is required.';
            if (!data.siteGroup) errors.siteGroup = 'Site Group is required.';
            if (!data.title) errors.title = 'Title is required.';
            if (!data.region) errors.region = 'Region is required.';
            if (!data.country) errors.country = 'Country is required.';
            if (!data.city) errors.city = 'City is required.';
            if (!data.siteLocation) errors.siteLocation = 'Site Location is required.';
            if (!data.status) errors.status = 'Status is required.';
            if (!data.timeZone) errors.status = 'Time Zone is required.';
            return errors;
        },
        onSubmit: (values) => {
            const data = {
                ...values,
                siteId: typeof values?.siteId === 'string' ? Number(values?.siteId) : values?.siteId,
                siteGroup: values?.siteGroup?.join(',') || '',
                id: isEditMode ? site?.id : null,
                lastUpdatedBy: currentUser?.userId,
            }
            handleCreate(data);
        },
    });

    const isFormFieldValid = (name) =>
        !!(formik.touched[name] && formik.errors[name]);

    const getFormErrorMessage = (name) => {
        return (
            isFormFieldValid(name) && (
                <small className="p-error">{formik.errors[name]}</small>
            )
        );
    };

    const handleCreate = (data) => {
        if (isEditMode) {
            dispatch(appActions.SITES_UPDATE_REQUEST(data));
        } else {
            delete data?.id
            dispatch(appActions.SITES_CREATE_REQUEST(data));
        }
        onSave();
        onClose();
    };

    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <form onSubmit={formik.handleSubmit}>
                <div className="grid formgrid mt-2">

                    <div className="field col-4">
                        <label htmlFor="siteId" className="flex align-items-center required"> Site Id </label>
                        <InputText
                            type="number"
                            className="w-full"
                            id="siteId"
                            value={formik.values.siteId}
                            onChange={formik.handleChange}
                            placeholder="Site Id"
                            disabled={isViewMode}
                        />
                        {getFormErrorMessage('siteId')}
                    </div>

                    <div className="field col-4">
                        <label htmlFor="siteType" className="flex align-items-center required"> Site Type </label>
                        <InputText
                            className="w-full"
                            id="siteType"
                            value={formik.values.siteType}
                            onChange={formik.handleChange}
                            placeholder="Site Type"
                            disabled={isViewMode}
                        />
                        {getFormErrorMessage('Site Type')}
                    </div>

                    <div className="field col-4">
                        <label htmlFor="siteGroup" className="flex align-items-center required"> Site Group </label>
                        {/* <InputText
                            className="w-full"
                            id="siteGroup"
                            value={formik.values.siteGroup}
                            onChange={formik.handleChange}
                            placeholder="Site Group"
                            disabled={isViewMode}
                        /> */}
                        <MultiSelect 
                        id="siteGroup"
                        value={formik.values.siteGroup} 
                        onChange={(e) => formik.setFieldValue('siteGroup', e.value)} 
                        options={siteGroupOptions}
                        optionLabel="label" 
                        filter 
                        placeholder="Select Site Group" 
                        disabled={isViewMode}
                        className="w-full"
                        maxSelectedLabels={3}  />
                        
                        {getFormErrorMessage('siteGroup')}
                    </div>

                    <div className="field col-4">
                        <label htmlFor="title" className="flex align-items-center required"> Title </label>
                        <InputText
                            className="w-full"
                            id="title"
                            value={formik.values.title}
                            onChange={formik.handleChange}
                            placeholder="Title"
                            disabled={isViewMode}
                        />
                        {getFormErrorMessage('title')}
                    </div>
                    <div className="field col-4">
                        <label htmlFor="description" className="flex align-items-center required"> Description </label>
                        <InputText
                            className="w-full"
                            id="description"
                            value={formik.values.description}
                            onChange={formik.handleChange}
                            placeholder="description"
                            disabled={isViewMode}
                        />
                        {getFormErrorMessage('description')}
                    </div>

                    <div className="field col-4">
                        <label htmlFor="region" className="flex align-items-center required"> Region </label>
                        <InputText
                            className="w-full"
                            id="region"
                            value={formik.values.region}
                            onChange={formik.handleChange}
                            placeholder="Region"
                            disabled={isViewMode}
                        />
                        {getFormErrorMessage('region')}
                    </div>

                    <div className="field col-4">
                        <label htmlFor="country" className="flex align-items-center required"> Country </label>
                        <InputText
                            className="w-full"
                            id="country"
                            value={formik.values.country}
                            onChange={formik.handleChange}
                            placeholder="Country"
                            disabled={isViewMode}
                        />
                        {getFormErrorMessage('country')}
                    </div>

                    <div className="field col-4">
                        <label htmlFor="city" className="flex align-items-center required"> City </label>
                        <InputText
                            className="w-full"
                            id="city"
                            value={formik.values.city}
                            onChange={formik.handleChange}
                            placeholder="City"
                            disabled={isViewMode}
                        />
                        {getFormErrorMessage('city')}
                    </div>

                    <div className="field col-4">
                        <label htmlFor="siteLocation" className="flex align-items-center required"> Site Location </label>
                        <InputText
                            className="w-full"
                            id="siteLocation"
                            value={formik.values.siteLocation}
                            onChange={formik.handleChange}
                            placeholder="Site Location"
                            disabled={isViewMode}
                        />
                        {getFormErrorMessage('siteLocation')}
                    </div>

                    <div className="field col-4">
                        <label htmlFor="timeZone" className="flex align-items-center required"> Time Zone </label>
                         <Dropdown filter value={formik.values.timeZone}
                            onChange={(e) => formik.setFieldValue('timeZone', e.value)}
                            options={timeZonesOptions}
                            optionLabel="name"
                            optionValue="name"
                            placeholder="Select a timezone"
                            valueTemplate={selectedTimeZoneTemplate}
                            itemTemplate={timeZoneOptionTemplate} 
                            disabled={isViewMode}
                             className='w-full'
                            id="timeZone"
                            name="timeZone"
                        />
                        {getFormErrorMessage('timeZone')}
                    </div>

                    <div className="field col-4">
                        <label htmlFor="status" className="flex align-items-center required"> Status </label>
                        <Dropdown
                            className="w-full"
                            id="status"
                            value={formik.values.status}
                            options={statusOptions}
                            optionLabel="name"
                            optionValue='code'
                            onChange={(e) => formik.setFieldValue('status', e.value)}
                            placeholder="Status"
                            disabled={isViewMode}
                        />
                        {getFormErrorMessage('status')}
                    </div>

                    <div className="field col-12">
                        <div className="flex justify-content-end mt-4">
                            {isViewMode ? (
                                <Button
                                    type="button"
                                    label="Close"
                                    onClick={handleClose}
                                    severity="secondary"
                                />
                            ) : (
                                <Button
                                    type="submit"
                                    label={isEditMode ? 'Update' : 'Create'}
                                    severity="basic"
                                />
                            )}
                        </div>
                    </div>
                </div>
            </form>
        </>
    );
}

export default SitesForm;
